export default __webpack_public_path__ + "static/genopets-2-a-5dcd350b58c1722bd74acf98790759cb.webp";